import { templateToTitle } from '@apps/card/utils';
import { StationeryTemplateCategoryEnum } from '@graphql/generated';
import { Box, Flex, TextV2 } from '@withjoy/joykit';
import React from 'react';
import { useIsMobileScreen } from '@shared/utils/media/useMediaScreens';
import { useAuth } from '@shared/components/AuthProvider';
import { useCardsRouterContext } from '@apps/card/Card.routes';
import { ProductPrices } from '../../DesignsGallery/components/GalleryItem/components/ProductPrices/ProductPrices';
import { useCardTelemetry } from '@apps/card/Card.telemetry';
import { Link, useTranslation } from '@shared/core';
import { useDesignTemplates } from '../../DesignsGallery/useDesignTemplates';
import { GalleryTile } from '../../GalleryTile';
import { desktopAspect, mobileAspect, tileRowGap } from '../../DesignsGallery/components/CardsConfig';

interface RelatedItemsProps {
  category: StationeryTemplateCategoryEnum;
  themeId: string;
}

const CATEGORIES = Object.values(StationeryTemplateCategoryEnum);

export const RelatedItems: React.FC<RelatedItemsProps> = ({ category, themeId }) => {
  const { tq } = useTranslation('stationery');
  const { isSuperAdmin } = useAuth();
  const isMobile = useIsMobileScreen();

  const templates = useDesignTemplates({ categories: CATEGORIES.filter(c => c !== category), themeIds: [themeId], skipDigitalDesigns: true });

  const { getProductDetailsPagePath } = useCardsRouterContext();
  const { pdpMatchingDesignClicked } = useCardTelemetry();

  if (!templates?.length) return null;

  return (
    <Flex
      flexDirection="column"
      gap={{ _: 8, sm2: 10 }}
      paddingTop={{ _: 8, sm2: 10 }}
      paddingX={{ _: 6, sm2: 7 }}
      width="100%"
      marginBottom={10}
    >
      <TextV2
        fontWeight={{ sm2: 600 }}
        typographyVariant={{ _: 'hed4', sm2: 'display2' }}
        width="100%"
        textAlign="center"
      >
        {tq`Shop Matching Designs`}
      </TextV2>
      <Box
        display="grid"
        width="100%"
        gridTemplateColumns={{
          _: 'repeat(2, 1fr)',
          sm2: 'repeat(3, 1fr)',
          md3: 'repeat(4, 1fr)',
        }}
        columnGap={1}
        rowGap={{ _: 4, sm2: 6 }}
      >
        {templates.map(template => {
          if (!template.enabled && !isSuperAdmin) {
            return null;
          }

          return (
            <GalleryTile
              key={template.id}
              aspectRatio={isMobile ? mobileAspect : desktopAspect}
              alignContent="start"
              rowGap={tileRowGap}
              as={Link}
              to={getProductDetailsPagePath('wedding', template.category, template.themeId, template.id)}
              onClick={() => pdpMatchingDesignClicked({ category: template.category })}
            >
              <GalleryTile.AssetPreview assetUrl={(template.thumbnailUrl || template.digitalDesignThumbnailUrl) ?? ''} />
              <GalleryTile.Content
                title={templateToTitle(template)}
                label={
                  <ProductPrices
                    template={template}
                    explicitPaperDigitalCategory
                  />
                }
              />
            </GalleryTile>
          );
        })}
      </Box>
    </Flex>
  );
};
